import { apiDate, number, optionalNumber, optionalUuid, string, uuid, zodLess, ZodLessInfer } from '@kaiizen/zod-less';

// *******************************************************************
// Scan Photo API
// *******************************************************************
export const ApiScanPhotoSchema = zodLess({
  id: uuid,
  createdAt: apiDate,
  updatedAt: apiDate,
  mime: string,
  width: number,
  height: number,
  bytes: number,
  direction: optionalNumber,
  scanId: uuid,
});

export const ApiUpdateScanPhotoSchema = ApiScanPhotoSchema.omit({ id: true, createdAt: true, updatedAt: true }).partial();
export type ApiScanPhoto = ZodLessInfer<typeof ApiScanPhotoSchema>;
export type ApiUpdateScanPhoto = ZodLessInfer<typeof ApiUpdateScanPhotoSchema>;

// we have a special create scan-photo - since a file is also uploaded and all the fields are set from the file's metadata
export const ApiCreateScanPhotoSchema = zodLess({
  id: optionalUuid,
  scanId: string,
}, { ref: 'createScanPhoto' });
export type ApiCreateScanPhoto = ZodLessInfer<typeof ApiCreateScanPhotoSchema>;

export const getScanPhotoQueryKey = (photoId: string | undefined) => photoId ? `scan-photo/${photoId}` : '';
